import api from '@/api/api.js'

// PORT-001 : verdicts de paiement (be_caisse), un booléen a_jour par patient, jamais de montant.
// Réponse : { success: true, verdicts: [{ patient_id, a_jour }] }.
export default {
    getVerdictsPaiement(data, access_token) {
        return api.comptabilite().post('/portail/verdicts-paiement', { auth_id: data.auth_id, patient_ids: data.patient_ids },
            { headers: { 'X-Portail-Access': access_token }, med_access_scoped: true, timeout: 20000 }).then(response => response.data)
    }
}
